import client, { PRIVATE_CLIENT } from '../../services/client';
export const getContacts = async (business_id, page = 1) => {
    return await client.get(`business/${business_id}/contacts/`, PRIVATE_CLIENT, null, {
        page_index: page,
        page_size: 100,
        ordering: 'name'
    });
};
export const createContact = async (business_id, contact) => {
    return await client.post(`business/${business_id}/contacts/`, PRIVATE_CLIENT, contact);
};
export const createContacts = async (business_id, contact) => {
    return await client.post(`business/${business_id}/contacts/bulk-create/`, PRIVATE_CLIENT, {
        contacts: [contact],
    });
};
export const updateContact = async (business_id, contact, contact_id) => {
    return await client.patch(`business/${business_id}/contacts/${contact_id}/`, PRIVATE_CLIENT, contact);
};
